import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, PartPurchaseRepository, UtilityService } from 'app/core/core.module';
import { Part, PartBulkEdit } from 'app/core/model/entity-model';
import { PartDialogComponent } from 'app/shared/part-dialog/part-dialog.component';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { PartPurchaseOrderDialogComponent } from '../part-po-dialog/part-po-dialog.component';
import { confirm, custom } from 'devextreme/ui/dialog';

@Component({
    selector: 'app-part-bulk-edit-overview',
    templateUrl: './part-bulk-edit-overview.component.html',
    styleUrls: ['./part-bulk-edit-overview.component.scss'],
    standalone: false
})
export class PartBulkEditOverviewComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    partEdits: PartBulkEdit[];
    orders: any[];
    filter: any;
    isToastVisible = false;
    processing = false;
    showAsDialog = false;
    preferredVendor: string;
    selectedPartIds = [];
    orderLinePartsOnNew: any;
    showAllVendors: boolean = false;

    canSeeCost = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onOptionChangedShared = SharedModule.onOptionChanged;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private utility: UtilityService,
        private partPurchaseRepository: PartPurchaseRepository
    ) {}

    async ngOnInit() {
        await this.getData();
        this.canSeeCost = this.auth.hasRole('Parts:Admin') && !this.showAsDialog;
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const partEdits = (await this.uow.getPartBulkEdits()) as PartBulkEdit[];
        this.partEdits = partEdits;
        this.appInfo.pleaseWaitHide();
    }

    async submit() {
        const result = await confirm(`Are you ready to Submit?`,`${this.appInfo.settings.company}`);
        if (!result) return;


        const detailIds = _.uniq(
            this.partEdits.map((x) => {
                if (!x.sent) return x.orderLineDetailId;
            })
        );
        const today = new Date();
        await this.utility.processOrderLineDetails(detailIds);
        this.partEdits.forEach((partEdit) => {
            if (!partEdit.sent) partEdit.sent = today;
        });
        await this.uow.commit();
    }

    async selectionChange(e) {
        // console.log(e);
    }

    async rowPrepare(e) {
        if (e.rowType === 'data') {
            if (e.data.sent && !e.data.processed) {
                e.rowElement.className = e.rowElement.className + ' sent-line';
            }
            if (e.data.sent && e.data.processed) {
                console.log('here')
                e.rowElement.className = e.rowElement.className + ' processed-line';
            }
        }
    }

    async save() {
        this.isToastVisible = true;
        await this.uow.commit();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(partId: number) {
        this.router.navigate(['/parts/' + (partId ? partId : 'new')]);
    }

    async rowDoubleClick(e) {
        return;
        if (!e.data || !e.data.id) return;
        await this.open(e.data.id);
    }


}
